import React, { createContext, useContext, useMemo } from 'react';
import { useLocation } from 'react-router-dom';

const QueryParamsContext = createContext({});

export const QueryParamsProvider = ({ children }) => {
  const location = useLocation();

  const value = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return {
      hidegemini: params.get('hidegemini') === 'true',
      queryParams: params,
    };
  }, [location.search]);

  return (
    <QueryParamsContext.Provider value={value}>
      {children}
    </QueryParamsContext.Provider>
  );
};

export const useQueryParams = () => {
  const context = useContext(QueryParamsContext);
  if (!context) {
    throw new Error('useQueryParams must be used within a QueryParamsProvider');
  }
  return context;
};
